import { render, staticRenderFns } from "./LikeCriterion.vue?vue&type=template&id=15d22e0a&"
import script from "./LikeCriterion.vue?vue&type=script&lang=js&"
export * from "./LikeCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports